import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isSafeInternalPath } from "../../lib/navigation";

const NavigationHistoryContext = createContext({ previousPath: "" });

function locationKey(location) {
  return `${location.pathname}${location.search || ""}`;
}

export function NavigationHistoryProvider({ children }) {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState("");
  const [currentKey, setCurrentKey] = useState(locationKey(location));

  useEffect(() => {
    const nextKey = locationKey(location);
    if (nextKey === currentKey) return;
    if (isSafeInternalPath(currentKey)) {
      setPreviousPath(currentKey);
    }
    setCurrentKey(nextKey);
  }, [location, currentKey]);

  return (
    <NavigationHistoryContext.Provider value={{ previousPath }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
}

export function usePreviousPath() {
  return useContext(NavigationHistoryContext).previousPath;
}
